export default __webpack_public_path__ + "static/constellationSibling-9e99d134e03d1dd4a843dff0baca7699.svg";